import React from "react";
import { Link } from "react-router-dom";
import "./NoData.css";

const NoData = () => {
  return (
    <div className="nodata-container">
      <p className="nodata-label">Nothing here yet</p>
      <p className="nodata-sub">Add something to get started.</p>
      <Link to="/" className="nodata-btn">Continue Shopping</Link>
    </div>
  );
};

export default NoData;
